import { getSharedConfig as getSharedConfigInternal } from '@eversports/react-app-base/get-config'

import type { sharedConfig } from './config'

export const getSharedConfig = () => getSharedConfigInternal<typeof sharedConfig>()
